interface StatCardProps {
  icon: string;
  value: string | number;
  label: string;
  accent?: string;
}

export function StatCard({ icon, value, label, accent = 'text-primary' }: StatCardProps) {
  return (
    <div className="bg-white rounded-xl shadow-sm p-3.5">
      <div className="flex items-start justify-between mb-1">
        <span className="text-xl">{icon}</span>
      </div>
      <p className={`text-xl font-bold leading-tight ${accent}`}>{value}</p>
      <p className="text-[11px] text-slate-500 leading-tight mt-0.5">{label}</p>
    </div>
  );
}